/*********************************************************
 *                  Admin users Ctrl
 *
 ********************************************************/


"use strict";

angular.module("admin")
	.controller("AdminCompaniesEditCtrl", ["$scope", "$location", "Utils", "company", "mode", "clients", "$uibModal", "AdminCompaniesService", "toastr", function ($scope, $location, Utils, company, mode, clients, $uibModal, AdminCompaniesService, toastr) {

		/************************************************************************************************************
             *  SETUP
             *************************************************************************************************************/

		$scope.data = {
			company: company.data,
			mode: mode,
			clients: clients.data
		};

		var editCompanyModal;


		/************************************************************************************************************
             *  $scope functions
             *************************************************************************************************************/

		/**
		 * Ouvrir la popup permettant de modifier le nombre de réseaux.
		 */
		$scope.openEditCompanyModal = function () {
			editCompanyModal = Utils.openModal($uibModal, "edit.html", $scope);
		};


		$scope.post = function () {

			if ($scope.data.mode === "new") {

				AdminCompaniesService.addCompany($scope.data.company).then(() => {
					toastr.success("", "Compagnie créé");
					$location.path("/admin/companies");
				}).catch((response) => {
					const data = response.data;
					let errorMessage = "Problème lors de la création de la compagnie. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			} else if ($scope.data.mode === "edit") {
				AdminCompaniesService.edit($scope.data.company).then((response) => {
					toastr.success("", "Compagnie " + response.data.name + " mise à jour");
					$scope.data.company = response.data;
				}).catch((response) => {
					const data = response.data;
					let errorMessage = "Problème lors de la mise à jour de la compagnie. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			}
		};


	}]
	)
;